
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link, Image, Tracking } from 'contentbricks'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Image className='bigImage' file={require('images/grafik_mixed.jpg')} mdxType="Image" />
    <p>{`Da scheiden sich die Geister. Die Kombination von ASS, Paracetamol und Koffein
wirkt oft besser als die einzelnen Substanzen und soll durchschnittlich sieben
Minuten schneller wirken. Aber: Die Kombinationstablette führt rascher zu einem
Müks, der Entzug dauert länger und ist mühsamer. Deshalb wird davon abgeraten.
«Müks» steht für`}</p>
    <b>M</b>edikamenten-
    <b>Ü</b>bergebrauch-
    <b>K</b>opf
    <b>s</b>chmerz,
dass
die
Schmerzmittel
selbst
Kopfschmerzen
bereiten.
Wer
zu
Beginn
der
Kopfschmerzen
noch
Kaffee
mag,
kann
statt
der
Wirkstoffkombination
ein
Schmerzmittel
nehmen
und
einen
Espresso
mit
Zitrone
trinken.
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;